export default function Error({ message }) {
  return <div>{message}</div>;
}
